// extracted by css-extract-rspack-plugin
export default {"cls1":"RecommendationsCard-cls1_70O","cls2":"RecommendationsCard-cls2_HqB RecommendationsCard-cls1_70O"};